import { useEffect } from 'react';

import { FONEMI_FRONTPAGE_URL } from '~/shared/config';

function UserPolicy() {
  useEffect(() => {
    window.location.replace(`${FONEMI_FRONTPAGE_URL}/gebruikersvoorwaarden`);
  }, []);

  return null;
}
UserPolicy.options = {
  isPublic: true,
};

export default UserPolicy;
